import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeCreditsWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.credits",
  name: "Total credits",
  description: "Total credits for the selected dashboard period.",
  apps: [
    "home",
    "finance",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "credit",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Credits",
    subtext: "",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$162,900",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
